export interface INavigationRoute {
  name: string
  displayName: string
  meta: { icon: string }
  children?: INavigationRoute[]
}

//平台管理员菜单
export default {
  root: {
    name: '/',
    displayName: 'navigationRoutes.home',
  },
  routes: [
    {
      name: 'home',
      displayName: 'menu.home',
      meta: {
        icon: 'material-icons-cloud_upload',
      },
    },
     {
      name: 'themeManagement',
      displayName: 'menu.themeManagement',
      meta: {
        icon: 'material-icons-event_note',
      },
      children: [
        {
          name: 'themeList',
          displayName: 'menu.themeList',
        },
      ],
    },
    {
      name: 'templateManagement',
      displayName: 'menu.themeTemplateList',
      meta: {
        icon: 'material-icons-view_quilt',
      },
      children:[
        {
          name:'themeTemplateList',
          displayName: 'menu.themeTemplateList'
        },
        {
          name: 'themeTagList',
          displayName: 'menu.themeTagList',
        },
      ]
    },
    {
      name: 'assetManagement',
      displayName: 'menu.assetManagement',
      meta: {
        icon: 'material-icons-photo_library',
      },
      children: [
        {
          name: 'assetList',
          displayName: 'menu.assetList',
        },
        {
          name: 'assetTagList',
          displayName: 'menu.assetTagList',
        }
      ],
    },
     {
      name: 'accountManagement',
      displayName: 'menu.accountManagement',
      meta: {
        icon: 'material-icons-manage_accounts',
      },
      children: [
        {
          name: 'accountList',
          displayName: 'menu.accountList',
        },
        {
          name: 'menuList',
          displayName: 'menu.menuList',
        },
        {
          name: 'roleList',
          displayName: 'menu.roleList',
        },
         {
          name: 'setting',
          displayName: 'menu.setting',
        },
      ],
    },
     {
      name: 'shopManagement',
      displayName: 'menu.shopManagement',
      meta: {
        icon: 'material-icons-store',
      },
      children: [
        {
          name: 'shopList',
          displayName: 'menu.shopList',
        },
        {
          name: 'ShopAssociatedTerminals',
          displayName: 'menu.ShopAssociatedTerminals',
        },
        {
          name: 'ShopAssociatedAccount',
          displayName: 'menu.ShopAssociatedAccount',
        },
      ],
    },
    //终端管理
    {
      name: 'TerminalManagement',
      displayName: 'menu.TerminalManagement',
      meta: {
        icon: 'material-icons-terminal',
      },
      children: [
        {
          name: 'TerminalList',
          displayName: 'menu.TerminalList',
        },
        {
          name: 'TerminalAssociatedTheme',
          displayName: 'menu.TerminalAssociatedTheme',
        },
      ],
    },
     {
      name: 'dashboard',
      displayName: 'menu.dashboard',
      meta: {
        icon: 'material-icons-dashboard',
      },
    },
    {
      name: 'uploadTemplate',
      displayName: 'menu.uploadTemplate',
      meta: {
        icon: 'material-icons-view_quilt',
      },
      children: [
        {
          name: 'addTemplate',
          displayName: 'menu.addTemplate',
        },
        {
          name: 'tagList',
          displayName: 'menu.tagList',
        }
      ],
    },
     {
      name: 'usageStatistics',
      displayName: 'menu.usageStatistics',
      meta: {
        icon: 'material-icons-analytics',
      },
      children: [
        {
          name: 'SessionData',
          displayName: 'menu.SessionData',
        },
        {
          name: 'UsageSummary',
          displayName: 'menu.UsageSummary',
        },
        {
          name: 'SingleThemeData',
          displayName: 'menu.singleThemeData',
        },
        // ThemeSummary
        {
          name: 'ThemeSummary',
          displayName: 'menu.ThemeSummary',
        },
        // SingleCameraData
        {
          name: 'SingleCameraData',
          displayName: 'menu.SingleCameraData',
        },
        {
          name: 'CameraSummary',
          displayName: 'menu.CameraSummary',
        },
      ],
    }
  ] as INavigationRoute[],
}
